import {CanMatchFn} from '@angular/router';
import EntryService from '~local/app/shared/services/entry.service';
import {inject} from '@angular/core';
import {map} from 'rxjs/operators';
import {DialogService} from '~shared/ng/services/dialog/dialog.service';
import {SimpleModalType} from '~shared/types/dialog.types';


export const entryRegistrationGuard: CanMatchFn = () => {
    const entryService = inject(EntryService);
    const dialogService = inject(DialogService);

    return entryService.checkIpAddressStatus().pipe(
        map(($data) => {
            if (!$data || !$data.registrationEnabled) {
                dialogService.createSimple({
                    type: SimpleModalType.ERROR,
                    title: 'SWAL.REGISTRATION_DISABLED_TITLE',
                    content: 'SWAL.REGISTRATION_DISABLED_TEXT'
                });
                return false;
            }

            if ($data.regionRestricted) {
                dialogService.createSimple({
                    type: SimpleModalType.ERROR,
                    title: 'SWAL.REGION_RESTRICTED_TITLE',
                    content: 'SWAL.REGION_RESTRICTED_TEXT'
                });
                return false;
            }
            return true;
        })
    );
};
